"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDataSource = exports.EMPTY_PIVOT_QUERY_RESULT_DATA = void 0;
/**
 * Empty pivot query result data set
 *
 * @internal
 */
exports.EMPTY_PIVOT_QUERY_RESULT_DATA = {
    table: { columns: [], rows: [] },
};
/**
 * Runs type guard check for DataSource.
 *
 * @param arg
 * @internal
 */
function isDataSource(arg) {
    return arg === undefined || typeof arg === 'string' || ('title' in arg && 'type' in arg);
}
exports.isDataSource = isDataSource;
